import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createFsCacheProxy } from '@segment/utils/fsCache';
export var attributesToFetch = ["title", "url", "image", "label", "tags", "description", "cta", "featured"];
export var fetchResources = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var query, searchIndex, _ref$page, page, _ref$distinct, distinct, hitsPerPage, filters, cacheKey, enabled, algoliaCachedSearch;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, searchIndex = _ref.searchIndex, _ref$page = _ref.page, page = _ref$page === void 0 ? 0 : _ref$page, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, filters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return createFsCacheProxy(["resources-fetchResources"].concat(_toConsumableArray(cacheKey ? cacheKey : [query, page !== null && page !== void 0 ? page : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, filters !== null && filters !== void 0 ? filters : null])), function () {
              return searchIndex.search.apply(searchIndex, arguments).then(function (res) {
                return _objectSpread(_objectSpread({}, res), {}, {
                  hits: res.hits.map(function (hit) {
                    var _hit$image, _hit$image2;

                    return _objectSpread(_objectSpread({}, hit), {}, {
                      image: {
                        src: (_hit$image = hit.image) === null || _hit$image === void 0 ? void 0 : _hit$image.src,
                        title: (_hit$image2 = hit.image) === null || _hit$image2 === void 0 ? void 0 : _hit$image2.alt
                      }
                    });
                  })
                });
              });
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: page,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchResources(_x) {
    return _ref2.apply(this, arguments);
  };
}();